import { createRouter, createWebHistory } from 'vue-router';
import ProductPage from './components/ProductPage.vue';
import CartPage from './pages/CartPage.vue';
import HomePage from './pages/HomePage.vue';
import PageNotFound from './pages/PageNotFound.vue';
import PaymentFailPage from './pages/PaymentFailPage.vue';
import PaymentSuccessPage from './pages/PaymentSuccessPage.vue';
import PayoutFailPage from './pages/PayoutFailPage.vue';
import PayoutSuccessPage from './pages/PayoutSuccessPage.vue';
import ProductListPage from './pages/ProductListPage.vue';
import ProfilePage from './pages/ProfilePage.vue';
import SellSkin from './pages/SellSkin.vue';
import SigninPage from './pages/SigninPage.vue';
import SignupPage from './pages/SignupPage.vue';
import TextPage from './pages/TextPage.vue';

const routes = [
	{
		path: '/',
		name: 'HomePage',
		component: HomePage,
	},
	{
		path: '/signin',
		name: 'SigninPage',
		component: SigninPage,
	},
	{
		path: '/singup',
		name: 'SignupPage',
		component: SignupPage,
	},
	{
		path: '/products/:itemType?',
		name: 'ProductListPage',
		component: ProductListPage,
		props: true,
	},
	{
		path: '/product/:id',
		name: 'ProductPage',
		component: ProductPage,
		props: true,
	},
	{
		path: '/profile/:page?',
		name: 'ProfilePage',
		component: ProfilePage,
	},
	{
		path: '/cart',
		name: 'CartPage',
		component: CartPage,
	},
	{
		path: '/success-payment',
		name: 'PaymentSuccessPage',
		component: PaymentSuccessPage,
	},
	{
		path: '/fail-payment',
		name: 'PaymentFailPage',
		component: PaymentFailPage,
	},
	{
		path: '/success-payout',
		name: 'PayoutSuccessPage',
		component: PayoutSuccessPage,
	},
	{
		path: '/fail-payout',
		name: 'PayoutFailPage',
		component: PayoutFailPage,
	},
	{
		path: '/sell-skin',
		name: 'SellSkin',
		component: SellSkin,
	},
	{
		path: '/:slug',
		name: 'TextPage',
		component: TextPage,
		props: true,
	},
	{
		path: '/:slug/:id(\\d+)',
		name: 'TextPageLegacy',
		component: TextPage,
		props: true,
	},
	{
		path: '/:pathMatch(.*)*',
		name: 'PageNotFound',
		component: PageNotFound,
	},
];

const router = createRouter({
	history: createWebHistory(process.env.BASE_URL),
	routes,
});

export default router;
